import { render, staticRenderFns } from "./VenueList.vue?vue&type=template&id=2653b5cf"
import script from "./VenueList.vue?vue&type=script&lang=js"
export * from "./VenueList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports